import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Heart } from "lucide-react";

interface ManifestationCompleteDialogProps {
  open: boolean;
  onClose: () => void;
}

const ManifestationCompleteDialog: React.FC<ManifestationCompleteDialogProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md text-center">
        <DialogHeader className="items-center">
          <Sparkles className="h-10 w-10 text-primary mb-2" />
          <DialogTitle className="text-xl">Session Complete ✨</DialogTitle>
          <DialogDescription className="text-base mt-2">
            Beautiful work! Your manifestation session is complete. Ready to deepen your practice with gratitude?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex-col gap-2 sm:flex-col mt-4">
          <Button
            className="w-full gap-2"
            onClick={() => {
              onClose();
              navigate("/dashboard/gratitude");
            }}
          >
            <Heart className="h-4 w-4" />
            Continue to Gratitude Practice
          </Button>
          <Button
            variant="outline"
            className="w-full"
            onClick={() => {
              onClose();
              navigate("/dashboard");
            }}
          >
            Back to Dashboard
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ManifestationCompleteDialog;
